<template>
  <v-layout fill-height column>
    <div class="progress-steps">
      <EmotionProgressHigh :current="4"/>
    </div>
    <div class="question min-height" v-html="ques[0]"></div>
    <div class="answer">
      <div class="text-center pb-5">
        <v-btn plain :ripple="false"
               class="primary--text"
               style="border-radius: 20px;"
               :style="{backgroundColor:bgColor}"
               @click="sheet = true">
          감정 보기<img :src="getImage('ic_down_arrow2.svg')" class="ml-2">
        </v-btn>
      </div>
      <!-- <div class="fs-14 gray400--text text-center pb-8">(앞으로 비슷한 일이 생기면 어떻게 하는게 좋을까요)</div> -->
      <div>
        <Textarea v-if="cmplt"
                  :value="textarea"
                  :height="200"
                  :counter="500"
                  :placeholder="replyArr[0]"
                  @input="textareaVaule"
                  readonly
        />
        <Textarea v-else
                  :value="textarea"
                  :height="200"
                  :counter="500"
                  :placeholder="replyArr[0]"
                  @input="textareaVaule"
        />
      </div>
    </div>
    <FooterBtnsNext @before="$emit('before')" @next="setMemberReply" :current="current" :total="total"
                    :disabledNext="disabledNext"/>
    <EmotionThermometerSheet :sheet="sheet"
                             :emotionChoiceList="emotionSelectParam"
                             @close="sheetClose"/>
  </v-layout>
</template>
<script>
import store from '@/store'
import Textarea from "@/components/forms/Textarea"
import EmotionProgressHigh from "@/components/progress/EmotionProgressHigh"
import FooterBtnsNext from "@/components/btns/FooterBtnsNext"
import EmotionThermometerSheet from "@/components/layout/bottomSheet/EmotionThermometerSheet";

export default {
  props: ["current", "total", "unitUseNo", "unitDtlUseList", "freeYn", "cmpltYn", "unitDtlUseNo", "unitDtlPageSeq", "emotionSelectParam"],
  data: () => ({
    textarea: '',
    disabledNext: true,
    free: 'N',
    cmplt: false,
    ques: [],
    replyArr: [],
    replyObjArr: [],
    userReplyNo: [0],
    userReply: [],
    sheet: false,
    bgColor: '#E9E6FE',
  }),
  components: {
    EmotionProgressHigh,
    Textarea,
    FooterBtnsNext,
    EmotionThermometerSheet,
  },
  mounted() {
    this.getUnitDetailUse()
  },
  created() {
  },
  methods: {
    async getUnitDetailUse() {
      // 무료 여부
      this.free = this.freeYn
      // 완료 여부
      this.cmplt = this.cmpltYn
      // this.cmplt = true
      await store.dispatch('getUnitDetailUse', this.$_payload('so',
          [{'unitUseNo': this.unitUseNo},
            {'unitDtlUseNo': this.unitDtlUseNo[this.current - 1]},
            {'unitDtlPageSeq': this.unitDtlPageSeq[this.current - 1]},
            {'freeYn': this.free},
            {'feedbackUserKey': this.$route.query.feedbackUserKey}
          ]))
        .then(res => {
          if (res.success) {

            // 질문 리스트
            res.data.unitDtlQuesList.forEach((quesEl, i) => {

              // 질문 셋팅
              // this.ques[i] = quesEl.ques
              this.ques.push(quesEl.ques)

              // 답변 셋팅
              quesEl.unitDtlReplyList.forEach((replyEl) => {
                // 렌더링 때문에 답변따로 먼저 저장 후 객체도 저장
                this.replyArr.push(replyEl.reply)
                this.replyObjArr.push(replyEl)
              });

              // 유저 답변 셋팅
              quesEl.memberUnitDtlReplyList.forEach((userReplyEl, j) => {
                this.userReplyNo[i + j] = userReplyEl.memberUnitDtlReplyUseNo
                this.textarea = userReplyEl.reply
                this.textareaVaule(this.textarea)
              });
            });

          } else {
            console.log(res.msg)
            // this.answer = [];
          }
        })
        .catch(error => {
          console.error(error)
          // this.answer = [];
        })
        .finally(() => {
        })
    },
    async setMemberReply() {

      if (!this.cmplt) { // 완료상태가 아닐때만 저장
        // 서술형 답변
        let replyObj = this.replyObjArr[0]
        this.userReply[0] = {
          unitId: replyObj.unitId,
          sltUnitMappingUseNo: replyObj.sltUnitMappingUseNo,

          memberUnitDtlReplyUseNo: this.userReplyNo[0],
          // unitUseNo: replyObj.unitUseNo,
          unitNo: replyObj.unitNo,
          // unitDtlUseNo: replyObj.unitDtlUseNo,
          unitDtlNo: replyObj.unitDtlNo,
          // unitDtlQuesUseNo: replyObj.unitDtlQuesUseNo,
          unitDtlQuesNo: replyObj.unitDtlQuesNo,
          // unitDtlReplyUseNo: replyObj.unitDtlReplyUseNo,
          unitDtlReplyNo: replyObj.unitDtlReplyNo,
          userKey: this.$store.state.auth.authUser.userKey,
          reply: this.textarea,
          // score: score/10,
          freeYn: this.free
        }

        console.log('this.userReply : ', this.userReply);

        await store.dispatch('setMemberReply', this.$_payload('memberReplyList', this.userReply))
          .then(res => {
            if (res.success) {
              setTimeout(() => this.$emit('next'), 500); // 저장한 이후
            } else {
              console.log(res.msg)
            }
          })
          .catch(error => {
            console.error(error)
          })
          .finally(() => {
          })
      } else {
        this.$emit('next')
      }
    },
    textareaVaule(value) {
      this.textarea = value;
      if (this.textarea == "" || this.textarea.length > 500) {
        this.disabledNext = true
      } else {
        this.disabledNext = false
      }
    },
    sheetClose() {
      this.sheet = false
    }
  }
}
</script>
